var _rect, _circle, _circle2, _path, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip1500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "url(#paint0_linear_1605_4110)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 34.5,
    stroke: "white",
    strokeWidth: 7,
    strokeMiterlimit: 2.16568,
    strokeDasharray: "15 10"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 25.5,
    fill: "black",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8594 43H24.4453V36.3906C24.4453 36.2083 24.4479 35.9844 24.4531 35.7188C24.4583 35.4479 24.4661 35.1719 24.4766 34.8906C24.487 34.6042 24.4974 34.3464 24.5078 34.1172C24.4505 34.1849 24.3333 34.3021 24.1562 34.4688C23.9844 34.6302 23.8229 34.776 23.6719 34.9062L22.3594 35.9609L21.1953 34.5078L24.875 31.5781H26.8594V43ZM30.3203 41.8828C30.3203 41.3932 30.4531 41.0495 30.7188 40.8516C30.9896 40.6536 31.3151 40.5547 31.6953 40.5547C32.0651 40.5547 32.3828 40.6536 32.6484 40.8516C32.9193 41.0495 33.0547 41.3932 33.0547 41.8828C33.0547 42.3516 32.9193 42.6901 32.6484 42.8984C32.3828 43.1068 32.0651 43.2109 31.6953 43.2109C31.3151 43.2109 30.9896 43.1068 30.7188 42.8984C30.4531 42.6901 30.3203 42.3516 30.3203 41.8828ZM38.7656 35.7031C39.4635 35.7031 40.0833 35.8359 40.625 36.1016C41.1719 36.3672 41.6016 36.7578 41.9141 37.2734C42.2266 37.7891 42.3828 38.4245 42.3828 39.1797C42.3828 40.0026 42.2109 40.7135 41.8672 41.3125C41.5286 41.9062 41.0208 42.362 40.3438 42.6797C39.6719 42.9974 38.8333 43.1562 37.8281 43.1562C37.2292 43.1562 36.6641 43.1042 36.1328 43C35.6068 42.901 35.1458 42.7474 34.75 42.5391V40.4531C35.1458 40.6615 35.6198 40.8385 36.1719 40.9844C36.7292 41.125 37.2526 41.1953 37.7422 41.1953C38.2214 41.1953 38.625 41.1328 38.9531 41.0078C39.2812 40.8776 39.5286 40.6797 39.6953 40.4141C39.8672 40.1432 39.9531 39.7995 39.9531 39.3828C39.9531 38.8255 39.7656 38.3984 39.3906 38.1016C39.0156 37.8047 38.4401 37.6562 37.6641 37.6562C37.3672 37.6562 37.0573 37.6849 36.7344 37.7422C36.4167 37.7995 36.151 37.8568 35.9375 37.9141L34.9766 37.3984L35.4062 31.5781H41.6016V33.625H37.5234L37.3125 35.8672C37.4896 35.8307 37.6823 35.7943 37.8906 35.7578C38.099 35.7214 38.3906 35.7031 38.7656 35.7031ZM53.75 43H51L48.0078 38.1875L46.9844 38.9219V43H44.5625V31.5781H46.9844V36.8047C47.1458 36.5807 47.3047 36.3568 47.4609 36.1328C47.6172 35.9089 47.776 35.6849 47.9375 35.4609L51.0312 31.5781H53.7188L49.7344 36.6328L53.75 43Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 20,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_4110",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.771913,
    stopColor: "#FF8855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAB1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip1500);
export default __webpack_public_path__ + "static/media/chip1500.22307b6ffdb3e92232f49fce8f51ca41.svg";
export { ForwardRef as ReactComponent };